import { Component, Inject, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { isProUser, isUltraUser } from '@/util/paid-user-util';

const appStoreState = namespace('appStore');

@Component({})
export default class PopupRequiredPaidAccountComponent extends Vue {
  @appStoreState.Getter
  public getIsShowPopupRequiredPaidAccount!: boolean;

  @appStoreState.Getter
  public getIsShowPopupRequiredOnlyUltra!: boolean;

  @appStoreState.Mutation
  public setIsShowPopupRequiredPaidAccount!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowPopupRequiredLogin!: (payload: boolean) => void;

  plan = 'Pro';

  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;

  handleClosePopupRequiredPaidAccount() {
    this.setIsShowPopupRequiredPaidAccount(false);
  }

  mounted() {
    this.plan = isUltraUser() ? 'Pro' : 'Ultra'; // upgrade to next plan: If free => Pro. If Pro => Ultra
  }

  routeToPlanPricing() {
    this.$router.push('/pricing-plan');
    this.handleClosePopupRequiredPaidAccount();
  }

  close() {
    this.setIsShowPopupRequiredPaidAccount(false);
  }
}
